import { Alert, AlertType, Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { inAppChatService } from '@egw/app-chat'

export const SignInChallengeFail: FC = () => {
  const { t } = useTranslation('features-auth')

  const clientServicesOnClick = (): void => {
    inAppChatService.open()
  }

  return (
    <div className="egw-container flex flex-col gap-4 h-full">
      <h1 className="typo-primary-xl-light text-text-header md:mt-2xl">{t('otp_challenge_fail.title')}</h1>
      <Alert alertType={AlertType.Error} className="w-fit" description={t('otp_challenge_fail.p1')} />
      <p className="typo-primary-base-regular text-text-meta">{t('otp_challenge_fail.p2')}</p>
      <div className="flex grow md:hidden" />
      <Button onClick={clientServicesOnClick} className="w-full md:w-fit">
        {t('otp_challenge_fail.cta')}
      </Button>
    </div>
  )
}
